import { useEffect } from 'react'

const useDeployTimeStamp = () => {
  useEffect(() => {
    const setTimestamp = async () => {
      const url = `${process.env.NEXT_PUBLIC_SITEURL}/${process.env.NEXT_PUBLIC_SERVICE_NAME}`
      const response = await fetch(`${url}/deploy_time.json`, {
        method: 'GET',
      })
      const data = await response.json()
      const deployTimestampNew = data.timestamp
      const DEPLOY_TIMESTAMP_OLD = localStorage.getItem(`${process.env.NEXT_PUBLIC_SERVICE_NAME}_DEPLOY_TIMESTAMP`)
      if (DEPLOY_TIMESTAMP_OLD === null) {
        location.reload()
        localStorage.setItem(`${process.env.NEXT_PUBLIC_SERVICE_NAME}_DEPLOY_TIMESTAMP`, deployTimestampNew)
      } else if (DEPLOY_TIMESTAMP_OLD !== deployTimestampNew) {
        localStorage.setItem(`${process.env.NEXT_PUBLIC_SERVICE_NAME}_DEPLOY_TIMESTAMP`, deployTimestampNew)
        location.reload()
      }
    }
    setTimestamp()
  }, [])
}

export default useDeployTimeStamp
